import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Trophy } from "lucide-react";
import { api } from "../../lib/api";
import { StandingsSection } from "./SportClub";

const PRIMARY = "#4F1B7C";
const SECONDARY = "#EC1F7C";
const BG_DARK = "#160732";

export default function SportClassementPage(props) {
  const settings = props.__settings;
  const [standings, setStandings] = useState([]);

  useEffect(() => {
    api.get("/sport/standings").then((r) => setStandings(r.data?.rows || [])).catch(() => {});
  }, []);

  return (
    <div className="bg-white" data-testid="sport-classement-page">
      {/* Hero */}
      <section className="relative pt-12 pb-8 sm:pt-16 sm:pb-12 overflow-hidden text-white"
               style={{ background: `linear-gradient(135deg, ${BG_DARK} 0%, ${PRIMARY} 100%)` }}>
        <div className="absolute inset-0 opacity-30 pointer-events-none"
             style={{ background: `radial-gradient(ellipse at 80% 0%, rgba(236,31,124,0.45), transparent 50%)` }}/>
        <div className="relative max-w-6xl mx-auto px-4 lg:px-8">
          <Link to="/sport" className="inline-flex items-center gap-2 text-white/70 hover:text-pink-300 transition text-xs font-black tracking-widest uppercase">
            <ArrowLeft size={14}/> Retour à l'accueil
          </Link>
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="mt-6 flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-2xl shrink-0"
                 style={{ background: `linear-gradient(135deg, ${SECONDARY}, #ff3a8c)` }}>
              <Trophy size={26}/>
            </div>
            <div>
              <div className="text-pink-300 font-black tracking-[0.3em] text-[10px] uppercase">{settings?.season || "2025-2026"}</div>
              <h1 className="font-blackhawk text-4xl sm:text-5xl uppercase italic leading-tight mt-1">Classement Liqui Moly StarLigue</h1>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Standings */}
      <StandingsSection rows={standings} settings={settings || {}}/>
    </div>
  );
}
